// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "root-kfXOF";
var _5 = "info-4QGn_";
var _6 = "title-3lUaE";
var _7 = "icon-2W7G9";
var _8 = "root_old-1D5Lr";
var _9 = "iconWrapper-2-8jh";
var _a = "root_note-31Orb";
var _b = "root_disabled-3IpDR";
var _c = "description__text-3D4PN";
var _d = "confirmedIcon-2MdW2";
var _e = "description-REbiu";
var _f = "warning-1kk5j";
var _10 = "rules-3YN5W";
var _11 = "root_fareLock-2oLeQ";
var _12 = "root_upgrade-23z81";
var _13 = "root_refund-3nP70";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "root", _5 as "info", _6 as "title", _7 as "icon", _8 as "root_old", _9 as "iconWrapper", _a as "root_note", _b as "root_disabled", _c as "description__text", _d as "confirmedIcon", _e as "description", _f as "warning", _10 as "rules", _11 as "root_fareLock", _12 as "root_upgrade", _13 as "root_refund" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "root": _4, "info": _5, "title": _6, "icon": _7, "root_old": _8, "iconWrapper": _9, "root_note": _a, "root_disabled": _b, "description__text": _c, "confirmedIcon": _d, "description": _e, "warning": _f, "rules": _10, "root_fareLock": _11, "root_upgrade": _12, "root_refund": _13 }
